/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type AllergyReactionTypes = typeof AllergyReactionTypes[keyof typeof AllergyReactionTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllergyReactionTypes = {
  Allergy: 'Allergy',
  AdverseReaction: 'AdverseReaction',
} as const;
